<template>
<div class="container-izracun">
    <form class="vue-form" @submit.prevent="calculate">
        <h2 class="naslov-za-izracun">
            KAKO ELEKTRIČNI RENAULT ČUVA OKOLIŠ?
        </h2>
        <p class="podnaslov">
            ALAT ZA IZRAČUN ENERGETSKIH UČINAKA I UČINAKA PO OKOLIŠ TIJEKOM RAZDOBLJA EKSPLOATACIJE BATERIJSKOG ELEKTRIČNOG VOZILA
        </p>
        <p class="tekst">
            Svi znamo da su električni automobili budućnost, ali koliko zaista oni troše energije i čuvaju okoliš? Pođite s nama na ovo zanimljivo putovanje i saznajte brojne prednosti zbog kojih ćete se još više zaljubiti u naše nove električne Renault modele.
        </p>

        <div class="buttonWrap">
            <button class="accordion border-1" type="button" @click="
            (ev) => {
              ev.currentTarget.classList.toggle('active');
            }
          ">
                O čemu se tu zapravo radi?
            </button>
            <div class="panel">
                <p>
                    Alat za izračun energetskih učinaka i učinaka po okoliš tijekom razdoblja eksploatacije baterijskog električnog vozila (BEV) daje uvid u korištenje BEV sa stajališta utjecaja na okoliš. Alat omogućuje informiranje i educiranje o nizu prednosti korištenja BEV te je pomoć prilikom odluke o kupnji. Naglasak se želi staviti na uštedu resursa i energije te posljedično smanjenje emisija CO2.
                </p>
                <p>
                    Svrha predmetnog projekta je formalizirati znanje i iskustvo koje postoji u akademskoj zajednici u oblik koji će omogućiti osmišljavanje i uspostavu inovativnog rješenja. Osmišljavanjem matematičkog modela kao osnove alata te definiranjem skupa informacija za bazu podataka vozila i referentnih podataka za izračun, u koju će biti ugrađeno iskustvo tvrtke Adria P.A., korisnicima će se pružiti uvid u energetske i okolišne učinke eksploatacije BEV, odnosno predstavljat će podlogu za razvoj slijednih aplikacija vezanih za područje elektromobilnosti. Navedeno će u razdoblju koje slijedi imati sve veću ulogu prilikom smanjenja ovisnosti transportnog sektora o fosilnim gorivima u sklopu energetske tranzicije ka niskougljičnom društvu.
                </p>
            </div>
        </div>
        <fieldset>
            <!--<div>
          <label class="label" for="cijena_ee">
            Cijena električne energije [kWh]
          </label>
          <input
            type="number"
            id="cijena_ee"
            class="form-control"
            v-model.number="cijena_el_energije"
            placeholder="0.8"
            min="0"
            step="0.1"
            required
          />
        </div> -->
            <div>
                <label class="label tooltip" for="em_faktor">
                    Kakav je energetski miks koji planirate koristiti za punjenje električnog Renaulta:
                    <div class="tooltiptext">
                        Zašto je to bitno? Što je „zelenija“ energija kojom punite električni Renault, to je manja emisija stakleničkih plinova.
                    </div>
                </label>
                <select class="form-control" v-model.number="emisijski_faktor" id="em_faktor" required>
                    <option value="0.106">100 % energija iz mreže</option>
                    <option value="0.080">75% energija iz mreže i 25% energija iz lokalnih obnovljivih izvora energije</option>
                    <option value="0.053">50% energija iz mreže i 50% energija iz lokalnih obnovljivih izvora energije</option>
                    <option value="0.027">75% energija iz lokalnih obnovljivih izvora energije i 25% energija iz mreže</option>
                    <option value="0">100 % energija iz lokalnih obnovljivih izvora energije</option>
                </select>
            </div>
            <!-- <div>
          <label class="label" for="euro_95">
            Cijena pogonskog energenta Eurosuper95 (kn)
          </label>
          <input
            type="number"
            id="euro_95"
            class="form-control"
            v-model.number="cijena_euro_95"
            placeholder="4"
            min="0"
            required
          />
        </div>
        <div>
          <label class="label" for="euro_100">
            Cijena pogonskog energenta Eurosuper100 (kn)
          </label>
          <input
            type="number"
            id="euro_100"
            class="form-control"
            v-model.number="cijena_euro_100"
            placeholder="4"
            min="0"
            required
          />
        </div>
        <div>
          <label class="label" for="dg_euro">
            Cijena pogonskog energenta drugo gorivo (kn)
          </label>
          <input
            type="number"
            id="dg_euro"
            class="form-control"
            v-model.number="cijena_dg_euro"
            placeholder="4"
            min="0"
            required
          />
        </div> -->
            <div>
                <label class="label tooltip" for="godisnja_km">
                    Koliko prosječno kilometara godišnje vozite?
                    <div class="tooltiptext">
                        Zašto je to bitno? Što više kilometara vozite s novim električnim Renaultom, to više doprinosite zaštiti okoliša.
                    </div>
                </label>
                <select class="form-control" id="godisnja_km" v-model="god_km" required>
                    <option value="10000">10.000</option>
                    <option value="12500">12.500</option>
                    <option value="15000" selected>15.000</option>
                    <option value="17500">17.500</option>
                    <option value="20000">20.000</option>
                </select>
            </div>

            <div>
                <h4>Odaberite svoj novi električni Renault za usporedbu</h4>
                <input class="checkbox-cars form-control" type="radio" name="cars" id="car-1" v-model="odabir_auta" value="Clio" required />
                <label class="for-checkbox-cars" for="car-1">
                    <img src="../assets/novi-clio.jpg" alt="Osobni automobil Clio" />
                    Zoe/Clio
                </label>
                <input class="checkbox-cars" type="radio" name="cars" id="car-2" v-model="odabir_auta" value="Twingo" required />
                <label class="for-checkbox-cars" for="car-2">
                    <img src="../assets/renault-twingo.jpg" alt="Osobni automobil Twingo" />
                    Twingo Z.E./Twingo
                </label>
                <input class="checkbox-cars form-control" type="radio" name="cars" id="car-3" v-model="odabir_auta" value="Captur" required />
                <label class="for-checkbox-cars" for="car-3">
                    <img src="../assets/captur.png" alt="Osobni automobil Captur" />
                    Captur/Captur E-Tech
                </label>
                <input class="checkbox-cars" type="radio" name="cars" id="car-4" v-model="odabir_auta" value="Megane" required />
                <label class="for-checkbox-cars" for="car-4">
                    <img src="../assets/megane.png" alt="Osobni automobil Megane" />
                    Megane/Megane E-Tech
                </label>
            </div>
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Prosječna potrošnja goriva [l/100km]</th>
                        <th colspan="2">Prosječna potrošnja električne energije [kWh/100km]</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Clio</strong></td>
                        <td><strong>Twingo</strong></td>
                        <td><strong>Zoe</strong></td>
                        <td><strong>Twingo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{auti[1].prosj_pot_en}}
                        </td>
                        <td>
                            {{auti[3].prosj_pot_en}}
                        </td>
                        <td>
                            {{auti[0].prosj_pot_en}}
                        </td>
                        <td>
                            {{auti[2].prosj_pot_en}}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Captur</strong></td>
                        <td><strong>Megane</strong></td>
                        <td><strong>Captur E-Tech</strong></td>
                        <td><strong>Megane E-Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{auti[5].prosj_pot_en}}
                        </td>
                        <td>
                            {{auti[7].prosj_pot_en}}
                        </td>
                        <td>
                            {{auti[4].prosj_pot_en2}}
                        </td>
                        <td>
                            {{auti[6].prosj_pot_en2}}
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="padding">
                <input type="submit" value="Krenimo na putovanje s Vašim novim električnim Renaultom!" />
            </div>
        </fieldset>
    </form>

    <div class="rezultat" v-if="doneCalculate && odabir_auta == 'Clio'">
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">Ušteda</h2>
        <p class="smallerText">
            Električni automobil emitira čak 95% manje CO<sub>2</sub>, odnosno u vašem slučaju 1,583 tona CO<sub>2</sub> u odnosu na model s klasičnim motorom. Da budemo svjesni koja je to ogromna količina koju možemo osobno uštedjeti i time doprinijeti borbi protiv klimatskih promjena, kažimo da povratni let ekonomske klase iz Londona za New York uzrokuje oko 1,8 tona CO<sub>2</sub>.
        </p>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Ukupna emisija (t CO<sub>2</sub>/god)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Clio</strong></td>
                        <td><strong>Zoe</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_emisija_clio) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_emisija_zoe) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Isplativost vozila po godinama</h2>
            <div class="padding"></div>
            <canvas id="lineZoeClio"></canvas>
        </div>
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">
            Razlika između konvencionalnog i električnog automobila
        </h2>
        <div class="padding"></div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">
                            Broj stabala koji bi bio potreban za apsorpciju CO<sub>2</sub>
                            na godišnjoj razini (kom / god)
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Clio</strong></td>
                        <td><strong>Zoe</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_drvece_clio) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_drvece_zoe) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">
                            Volumen morske vode koji bi bio potreban za apsorpciju CO<sub>2</sub>
                            na godišnjoj razini (m<sup>3</sup> / god)
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Clio</strong></td>
                        <td><strong>Zoe</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_voda_clio) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_voda_zoe) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Količina energije za vožnju na godišnjoj razini</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Clio</strong></td>
                        <td><strong>Zoe</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_clio)}} (l/god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_zoe)}} (kWh/god)
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!--<div class="padding">
        <table class="tablica-rezultati">
          <thead>
            <tr>
              <th colspan="2">Prosječna emisija CO<sub>2</sub> (g/km)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Clio</strong></td>
              <td><strong>Zoe</strong></td>
            </tr>
            <tr>
              <td>
                {{
                  new Intl.NumberFormat("de-DE").format(
                    auti[1].prosj_CO2_emisija
                  )
                }}
              </td>
              <td>
                {{
                  new Intl.NumberFormat("de-DE").format(
                    auti[0].prosj_CO2_emisija
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>-->
        <div class="rezultatiSlika">
            <div class="padding"></div>
            <h2 class="naslov-za-izracun">Što to konkretno znači za okoliš?</h2>
            <div class="padding"></div>
            <p>
                Desetogodišnje stablo u prosjeku apsorbira 22 kg CO2 godišnje, što znači kada vozite električni Renault svake godine kao da ste posadili
                {{
            new Intl.NumberFormat("de-DE").format(
              Math.round(usteda_drvece_zoe_clio)
            )
          }} stabala.
            </p>
            <p>
                Jeste li znali da i morska voda apsorbira CO2 i to 2,65g CO2 po litri? U našem slučaju to znači
                {{
              Math.round(usteda_voda_zoe_clio * 1000)
          }}
                ušteđenih litara morske vode.
            </p>

            <img src="../assets/ZOE-rezultati2.webp" class="rezultati-background clio_zoe" />
            <p class="drvece">
                {{
            new Intl.NumberFormat("de-DE").format(
              Math.round(usteda_drvece_zoe_clio)
            )
          }}
                <span>kom/god</span>
            </p>
            <p class="voda">
                {{
              Math.round(usteda_voda_zoe_clio * 1000)
          }}
                <span>l</span>
            </p>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Ušteda prilikom odabira električnog auta</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            CO<sub>2</sub> ekvivalent uklanjanja vozila iz prometa na
                            godišnjoj razini <br class="newLine" />
                            (kg CO<sub>2</sub> / god)
                        </td>
                        <td>
                            {{
                  new Intl.NumberFormat("de-DE").format(
                    uklanjanje_vozila_zoe_clio
                  )
                }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            CO<sub>2</sub> koji nije emitiran u atmosferu (tCO<sub>2</sub> /
                            god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(atmosfera_zoe_clio) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Točka pokrića kupovine električnog vozila</h2>
            <div class="padding"></div>
            <canvas id="lineExpenses"></canvas>
        </div>
        <div class="bottomText">
            <h3>
                Jeste li se već odlučili za kupnju novog električnog Renaulta?
            </h3>
            <p><a href="https://www.fzoeu.hr/hr/energetska_ucinkovitost/poticanje_energetske_ucinkovitosti_u_prometu/sufinanciranje_nabave_energetski_ucinkovitijih_vozila/" target="_blank">
                    Jeste li znali da pritom možete dobiti izdašnu subvenciju Fonda za zaštitu okoliša i energetsku učinkovitost?</a> </p>
            Kako biste se informirali i osobno doživjeli sve prednosti električnih vozila dobrodošli ste u naš prodajni centar na adresi Mihačeva draga 7 u Rijeci.
            Javite nam se za dogovor na <a href="tel:+38551226620">+385 51 226 620</a>, tu smo za Vas.
        </div>
    </div>

    <div class="rezultat" v-if="doneCalculate && odabir_auta == 'Twingo'">
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">Ušteda</h2>
        <p class="smallerText">
            Električni automobil emitira čak 95% manje CO<sub>2</sub>, odnosno u vašem slučaju 1,583 tona CO<sub>2</sub> u odnosu na model s klasičnim motorom. Da budemo svjesni koja je to ogromna količina koju možemo osobno uštedjeti i time doprinijeti borbi protiv klimatskih promjena, kažimo da povratni let ekonomske klase iz Londona za New York uzrokuje oko 1,8 tona CO<sub>2</sub>.
        </p>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Ukupna emisija (t CO<sub>2</sub>/god)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Twingo</strong></td>
                        <td><strong>Twingo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_emisija_twingo) }}
                        </td>
                        <td>
                            {{
                  new Intl.NumberFormat("de-DE").format(god_emisija_twingo_ze)
                }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Isplativost vozila po godinama</h2>
            <div class="padding"></div>
            <canvas id="lineTwingo"></canvas>
        </div>
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">
            Razlika između konvencionalnog i električnog automobila
        </h2>
        <div class="padding"></div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">
                            Broj stabala koji bi bio potreban za apsorpciju CO<sub>2</sub>
                            na godišnjoj razini (kom / god)
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Twingo</strong></td>
                        <td><strong>Twingo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{
                  new Intl.NumberFormat("de-DE").format(usteda_drvece_twingo)
                }}
                        </td>
                        <td>
                            {{
                  new Intl.NumberFormat("de-DE").format(usteda_drvece_twingo_ze)
                }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">
                            Volumen morske vode koji bi bio potreban za apsorpciju CO<sub>2</sub>
                            na godišnjoj razini (m<sup>3</sup> / god)
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Twingo</strong></td>
                        <td><strong>Twingo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_voda_twingo) }}
                        </td>
                        <td>
                            {{
                  new Intl.NumberFormat("de-DE").format(usteda_voda_twingo_ze)
                }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Količina energije za vožnju na godišnjoj razini</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Twingo</strong></td>
                        <td><strong>Twingo Z.E.</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{god_tro_pog_twingo}} (l/god)
                        </td>
                        <td>
                            {{god_tro_pog_twingo_ze}} (kWh/god)
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="padding">
        <table class="tablica-rezultati">
          <thead>
            <tr>
              <th colspan="2">Prosječna emisija CO<sub>2</sub> (g/km)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Twingo</strong></td>
              <td><strong>Twingo Z.E.</strong></td>
            </tr>
            <tr>
              <td>
                {{
                  new Intl.NumberFormat("de-DE").format(
                    auti[3].prosj_CO2_emisija
                  )
                }}
              </td>
              <td>
                {{
                  new Intl.NumberFormat("de-DE").format(
                    auti[2].prosj_CO2_emisija
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->
        <div class="rezultatiSlika">
            <div class="padding"></div>
            <h2 class="naslov-za-izracun">Što to konkretno znači za okoliš?</h2>
            <div class="padding"></div>
            <p>
                Desetogodišnje stablo u prosjeku apsorbira 22 kg CO2 godišnje, što znači kada vozite električni Renault svake godine kao da ste posadili {{
            new Intl.NumberFormat("de-DE").format(
              Math.round(usteda_drvece_twingo_ze_twingo)
            )
          }} stabala.
            </p>
            <p>
                Jeste li znali da i morska voda apsorbira CO2 i to 2,65g CO2 po litri? U našem slučaju to znači {{
            Math.round(usteda_voda_twingo_ze_twingo * 1000)
          }} ušteđenih litara morske vode.

            </p>
            <img src="../assets/twingoZE-rezultati.webp" class="rezultati-background twingo" />
            <p class="drvece">
                {{
            new Intl.NumberFormat("de-DE").format(
              Math.round(usteda_drvece_twingo_ze_twingo)
            )
          }}
                <span>kom/god</span>
            </p>
            <p class="voda">
                {{
            Math.round(usteda_voda_twingo_ze_twingo * 1000)
          }}
                <span>l</span>
            </p>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Ušteda prilikom odabira električnog auta</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            CO<sub>2</sub> ekvivalent uklanjanja vozila iz prometa na
                            godišnjoj razini <br class="newLine" />
                            (kg CO<sub>2</sub> / god)
                        </td>
                        <td>
                            {{
                  new Intl.NumberFormat("de-DE").format(
                    uklanjanje_vozila_twingo_ze_twingo
                  )
                }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            CO<sub>2</sub> koji nije emitiran u atmosferu (tCO<sub>2</sub> /
                            god)
                        </td>
                        <td>
                            {{
                  new Intl.NumberFormat("de-DE").format(
                    atmosfera_twingo_ze_twingo
                  )
                }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Točka pokrića kupovine električnog vozila</h2>
            <div class="padding"></div>
            <canvas id="lineExpenses"></canvas>
        </div>
        <div class="bottomText">
            <h3>
                Jeste li se već odlučili za kupnju novog električnog Renaulta?
            </h3>
            <p><a href="https://www.fzoeu.hr/hr/energetska_ucinkovitost/poticanje_energetske_ucinkovitosti_u_prometu/sufinanciranje_nabave_energetski_ucinkovitijih_vozila/" target="_blank">
                    Jeste li znali da pritom možete dobiti izdašnu subvenciju Fonda za zaštitu okoliša i energetsku učinkovitost?</a> </p>
            Kako biste se informirali i osobno doživjeli sve prednosti električnih vozila dobrodošli ste u naš prodajni centar na adresi Mihačeva draga 7 u Rijeci.
            Javite nam se za dogovor na <a href="tel:+38551226620">+385 51 226 620</a>, tu smo za Vas.
        </div>
    </div>

    <div class="rezultat" v-if="doneCalculate && odabir_auta == 'Captur'">
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">Ušteda</h2>
        <p class="smallerText">
            Električni automobil emitira čak 95% manje CO<sub>2</sub>, odnosno u vašem slučaju 1,583 tona CO<sub>2</sub> u odnosu na model s klasičnim motorom. Da budemo svjesni koja je to ogromna količina koju možemo osobno uštedjeti i time doprinijeti borbi protiv klimatskih promjena, kažimo da povratni let ekonomske klase iz Londona za New York uzrokuje oko 1,8 tona CO<sub>2</sub>.
        </p>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Ukupna emisija (t CO<sub>2</sub>/god)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Captur</strong></td>
                        <td><strong>Captur E-Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_emisija_captur) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_emisija_captur_tech) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Isplativost vozila po godinama</h2>
            <div class="padding"></div>
            <canvas id="lineCaptur"></canvas>
        </div>
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">
            Razlika između konvencionalnog i električnog automobila
        </h2>
        <div class="padding"></div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">
                            Broj stabala koji bi bio potreban za apsorpciju CO<sub>2</sub>
                            na godišnjoj razini (kom / god)
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Captur</strong></td>
                        <td><strong>Captur E-Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_drvece_captur) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_drvece_captur_tech) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">
                            Volumen morske vode koji bi bio potreban za apsorpciju CO<sub>2</sub>
                            na godišnjoj razini (m<sup>3</sup> / god)
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Captur</strong></td>
                        <td><strong>Captur E-Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_voda_captur) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_voda_captur_tech) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Količina energije za vožnju na godišnjoj razini</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Captur</strong></td>
                        <td><strong>Captur E-Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_captur)}} (l/god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_captur_tech)}} (kWh/god)
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!--<div class="padding">
        <table class="tablica-rezultati">
          <thead>
            <tr>
              <th colspan="2">Prosječna emisija CO<sub>2</sub> (g/km)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Clio</strong></td>
              <td><strong>Zoe</strong></td>
            </tr>
            <tr>
              <td>
                {{
                  new Intl.NumberFormat("de-DE").format(
                    auti[1].prosj_CO2_emisija
                  )
                }}
              </td>
              <td>
                {{
                  new Intl.NumberFormat("de-DE").format(
                    auti[0].prosj_CO2_emisija
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>-->
        <div class="rezultatiSlika">
            <div class="padding"></div>
            <h2 class="naslov-za-izracun">Što to konkretno znači za okoliš?</h2>
            <div class="padding"></div>
            <p>
                Desetogodišnje stablo u prosjeku apsorbira 22 kg CO2 godišnje, što znači kada vozite električni Renault svake godine kao da ste posadili
                {{
            new Intl.NumberFormat("de-DE").format(
              Math.round(usteda_drvece_captur_tech_captur)
            )
          }} stabala.
            </p>
            <p>
                Jeste li znali da i morska voda apsorbira CO2 i to 2,65g CO2 po litri? U našem slučaju to znači
                {{
              Math.round(usteda_voda_captur_tech_captur * 1000)
          }}
                ušteđenih litara morske vode.
            </p>

            <img src="../assets/captur-rezultati.jpg" class="rezultati-background Captur" />
            <p class="drvece">
                {{
            new Intl.NumberFormat("de-DE").format(
              Math.round(usteda_drvece_captur_tech_captur)
            )
          }}
                <span>kom/god</span>
            </p>
            <p class="voda">
                {{
              Math.round(usteda_voda_captur_tech_captur * 1000)
          }}
                <span>l</span>
            </p>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Ušteda prilikom odabira električnog auta</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            CO<sub>2</sub> ekvivalent uklanjanja vozila iz prometa na
                            godišnjoj razini <br class="newLine" />
                            (kg CO<sub>2</sub> / god)
                        </td>
                        <td>
                            {{
                  new Intl.NumberFormat("de-DE").format(
                    uklanjanje_vozila_captur_tech_captur
                  )
                }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            CO<sub>2</sub> koji nije emitiran u atmosferu (tCO<sub>2</sub> /
                            god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(atmosfera_captur_tech_captur) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Točka pokrića kupovine električnog vozila</h2>
            <div class="padding"></div>
            <canvas id="lineExpenses"></canvas>
        </div>
        <div class="bottomText">
            <h3>
                Jeste li se već odlučili za kupnju novog električnog Renaulta?
            </h3>
            <p><a href="https://www.fzoeu.hr/hr/energetska_ucinkovitost/poticanje_energetske_ucinkovitosti_u_prometu/sufinanciranje_nabave_energetski_ucinkovitijih_vozila/" target="_blank">
                    Jeste li znali da pritom možete dobiti izdašnu subvenciju Fonda za zaštitu okoliša i energetsku učinkovitost?</a> </p>
            Kako biste se informirali i osobno doživjeli sve prednosti električnih vozila dobrodošli ste u naš prodajni centar na adresi Mihačeva draga 7 u Rijeci.
            Javite nam se za dogovor na <a href="tel:+38551226620">+385 51 226 620</a>, tu smo za Vas.
        </div>
    </div>

    <div class="rezultat" v-if="doneCalculate && odabir_auta == 'Megane'">
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">Ušteda</h2>
        <p class="smallerText">
            Električni automobil emitira čak 95% manje CO<sub>2</sub>, odnosno u vašem slučaju 1,583 tona CO<sub>2</sub> u odnosu na model s klasičnim motorom. Da budemo svjesni koja je to ogromna količina koju možemo osobno uštedjeti i time doprinijeti borbi protiv klimatskih promjena, kažimo da povratni let ekonomske klase iz Londona za New York uzrokuje oko 1,8 tona CO<sub>2</sub>.
        </p>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Ukupna emisija (t CO<sub>2</sub>/god)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Megane</strong></td>
                        <td><strong>Megane E-Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_emisija_megane) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_emisija_megane_tech) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding"></div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Isplativost vozila po godinama</h2>
            <div class="padding"></div>
            <canvas id="lineMegane"></canvas>
        </div>
        <div class="padding"></div>
        <h2 class="naslov-za-izracun">
            Razlika između konvencionalnog i električnog automobila
        </h2>
        <div class="padding"></div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">
                            Broj stabala koji bi bio potreban za apsorpciju CO<sub>2</sub>
                            na godišnjoj razini (kom / god)
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Megane</strong></td>
                        <td><strong>Megane E-Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_drvece_megane) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_drvece_megane_tech) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">
                            Volumen morske vode koji bi bio potreban za apsorpciju CO<sub>2</sub>
                            na godišnjoj razini (m<sup>3</sup> / god)
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Megane</strong></td>
                        <td><strong>Megane E-Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_voda_megane) }}
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(usteda_voda_megane_tech) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Količina energije za vožnju na godišnjoj razini</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Megane</strong></td>
                        <td><strong>Megane E-Tech</strong></td>
                    </tr>
                    <tr>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_megane)}} (l/god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(god_tro_pog_megane_tech)}} (kWh/god)
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!--<div class="padding">
        <table class="tablica-rezultati">
          <thead>
            <tr>
              <th colspan="2">Prosječna emisija CO<sub>2</sub> (g/km)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Clio</strong></td>
              <td><strong>Zoe</strong></td>
            </tr>
            <tr>
              <td>
                {{
                  new Intl.NumberFormat("de-DE").format(
                    auti[1].prosj_CO2_emisija
                  )
                }}
              </td>
              <td>
                {{
                  new Intl.NumberFormat("de-DE").format(
                    auti[0].prosj_CO2_emisija
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>-->
        <div class="rezultatiSlika">
            <div class="padding"></div>
            <h2 class="naslov-za-izracun">Što to konkretno znači za okoliš?</h2>
            <div class="padding"></div>
            <p>
                Desetogodišnje stablo u prosjeku apsorbira 22 kg CO2 godišnje, što znači kada vozite električni Renault svake godine kao da ste posadili
                {{
            new Intl.NumberFormat("de-DE").format(
              Math.round(usteda_drvece_megane_tech_megane)
            )
          }} stabala.
            </p>
            <p>
                Jeste li znali da i morska voda apsorbira CO2 i to 2,65g CO2 po litri? U našem slučaju to znači
                {{
              Math.round(usteda_voda_megane_tech_megane * 1000)
          }}
                ušteđenih litara morske vode.
            </p>

            <img src="../assets/megane-rezultati.jpg" class="rezultati-background Megane" />
            <p class="drvece">
                {{
            new Intl.NumberFormat("de-DE").format(
              Math.round(usteda_drvece_megane_tech_megane)
            )
          }}
                <span>kom/god</span>
            </p>
            <p class="voda">
                {{
              Math.round(usteda_voda_megane_tech_megane * 1000)
          }}
                <span>l</span>
            </p>
        </div>
        <div class="padding">
            <table class="tablica-rezultati">
                <thead>
                    <tr>
                        <th colspan="2">Ušteda prilikom odabira električnog auta</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            CO<sub>2</sub> ekvivalent uklanjanja vozila iz prometa na
                            godišnjoj razini <br class="newLine" />
                            (kg CO<sub>2</sub> / god)
                        </td>
                        <td>
                            {{
                  new Intl.NumberFormat("de-DE").format(
                    uklanjanje_vozila_megane_tech_megane
                  )
                }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            CO<sub>2</sub> koji nije emitiran u atmosferu (tCO<sub>2</sub> /
                            god)
                        </td>
                        <td>
                            {{ new Intl.NumberFormat("de-DE").format(atmosfera_megane_tech_megane) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="padding">
            <h2 class="naslov-za-izracun">Točka pokrića kupovine električnog vozila</h2>
            <div class="padding"></div>
            <canvas id="lineExpenses"></canvas>
        </div>
        <div class="bottomText">
            <h3>
                Jeste li se već odlučili za kupnju novog električnog Renaulta?
            </h3>
            <p><a href="https://www.fzoeu.hr/hr/energetska_ucinkovitost/poticanje_energetske_ucinkovitosti_u_prometu/sufinanciranje_nabave_energetski_ucinkovitijih_vozila/" target="_blank">
                    Jeste li znali da pritom možete dobiti izdašnu subvenciju Fonda za zaštitu okoliša i energetsku učinkovitost?</a> </p>
            Kako biste se informirali i osobno doživjeli sve prednosti električnih vozila dobrodošli ste u naš prodajni centar na adresi Mihačeva draga 7 u Rijeci.
            Javite nam se za dogovor na <a href="tel:+38551226620">+385 51 226 620</a>, tu smo za Vas.
        </div>
    </div>
</div>
</template>

<script>
import Vue from "vue";
import Chart from 'chart.js'
export default {
    data() {
        return {
            auti: [{
                    id: 1,
                    name: "Zoe LIFE R110",
                    prosj_pot_en: 172,
                    prosj_CO2_emisija: 0.3,
                    kapacitet_bat: 52,
                    cijena_novog_voz: 220900,
                    subvencija: 70000,
                    ukupno_cijena: 150900,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 400,
                },
                {
                    id: 2,
                    name: "Novi Clio LIFE SCe 75",
                    prosj_pot_en: 5,
                    prosj_CO2_emisija: 111,
                    cijena_novog_voz: 98400,
                    ukupno_cijena: 98400,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 900,
                },
                {
                    id: 3,
                    name: "Twingo Z.E.",
                    prosj_pot_en: 163,
                    prosj_CO2_emisija: 0.3,
                    kapacitet_bat: 21.3,
                    cijena_novog_voz: 145050,
                    subvencija: 70000,
                    ukupno_cijena: 75050,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 400,
                },
                {
                    id: 4,
                    name: "Twingo",
                    prosj_pot_en: 4.5,
                    prosj_CO2_emisija: 99,
                    cijena_novog_voz: 74610,
                    ukupno_cijena: 74610,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 900,
                },
                {
                    id: 5,
                    name: "Captur E-Tech",
                    prosj_pot_en1: 1.5,
                    prosj_pot_en2: 19.4,
                    prosj_CO2_emisija: 34,
                    cijena_novog_voz: 227400,
                    subvencija: 70000,
                    ukupno_cijena: 157400,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 1750,
                },
                {
                    id: 6,
                    name: "Captur",
                    prosj_pot_en: 5.8,
                    prosj_CO2_emisija: 130,
                    cijena_novog_voz: 121200,
                    ukupno_cijena: 121200,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 1765,
                },
                {
                    id: 7,
                    name: "Megane E-Tech",
                    prosj_pot_en1: 1.6,
                    prosj_pot_en2: 18.1,
                    prosj_CO2_emisija: 29,
                    kapacitet_bat: null,
                    cijena_novog_voz: 241000,
                    subvencija: 70000,
                    ukupno_cijena: 171000,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 1765,
                },
                {
                    id: 8,
                    name: "Megane",
                    prosj_pot_en: 5.9,
                    prosj_CO2_emisija: 134,
                    cijena_novog_voz: 143000,
                    ukupno_cijena: 143000,
                    teh_i_reg: 1000,
                    osiguranje: 1100,
                    god_odrz: 1750,
                },
            ],

            cijena_el_energije: 0.8,
            cijena_euro_95: 9.02,
            cijena_euro_100: 9.68,
            cijena_dg_euro: 8.38,
            god_km: 15000,
            emisijski_faktor: 0.106,
            odabir_auta: null,

            doneCalculate: false,

            god_emisija_zoe: null,
            god_emisija_clio: null,
            god_emisija_twingo_ze: null,
            god_emisija_twingo: null,
            god_emisija_captur_tech: null,
            god_emisija_captur: null,
            god_emisija_megane_tech: null,
            god_emisija_megane: null,

            god_usteda_zoe_clio: null,
            god_usteda_twingo_ze_twingo: null,
            god_usteda_captur_tech_captur: null,
            god_usteda_megane_tech_megane: null,

            usteda_drvece_zoe: null,
            usteda_drvece_clio: null,
            usteda_drvece_twingo_ze: null,
            usteda_drvece_twingo: null,
            usteda_drvece_captur_tech: null,
            usteda_drvece_captur: null,
            usteda_drvece_megane_tech: null,
            usteda_drvece_megane: null,

            usteda_drvece_zoe_clio: null,
            usteda_drvece_twingo_ze_twingo: null,
            usteda_drvece_captur_tech_captur: null,
            usteda_drvece_megane_tech_megane: null,

            usteda_voda_zoe: null,
            usteda_voda_clio: null,
            usteda_voda_twingo_ze: null,
            usteda_voda_twingo: null,
            usteda_voda_captur_tech: null,
            usteda_voda_captur: null,
            usteda_voda_megane_tech: null,
            usteda_voda_megane: null,

            usteda_voda_zoe_clio: null,
            usteda_voda_twingo_ze_twingo: null,
            usteda_voda_captur_tech_captur: null,
            usteda_voda_megane_tech_megane: null,

            uklanjanje_vozila_zoe_clio: null,
            uklanjanje_vozila_twingo_ze_twingo: null,
            uklanjanje_vozila_captur_tech_captur: null,
            uklanjanje_vozila_megane_tech_megane: null,

            atmosfera_zoe_clio: null,
            atmosfera_twingo_ze_twingo: null,
            atmosfera_captur_tech_captur: null,
            atmosfera_megane_tech_megane: null,

            postotak_usteda: null,

            god_tro_pog_clio_help: null,
            god_tro_pog_zoe_help: null,
            god_tro_pog_twingo_ze_help: null,
            god_tro_pog_twingo_help: null,
            god_tro_pog_captur_help: null,
            god_tro_pog_captur_tech_help: null,
            god_tro_pog_megane_help: null,
            god_tro_pog_megane_tech_help: null,

            god_tro_pog_clio: null,
            god_tro_pog_zoe: null,
            god_tro_pog_twingo_ze: null,
            god_tro_pog_twingo: null,
            god_tro_pog_captur: null,
            god_tro_pog_captur_tech: null,
            god_tro_pog_megane: null,
            god_tro_pog_megane_tech: null,

            ukupni_troskovi_zoe: [],
            ukupni_troskovi_clio: [],
            ukupni_troskovi_twingo_ze: [],
            ukupni_troskovi_twingo: [],
            ukupni_troskovi_captur: [],
            ukupni_troskovi_captur_tech: [],
            ukupni_troskovi_megane: [],
            ukupni_troskovi_megane_tech: [],

            cijena_voz_po_god: [],
            fiksni_trosak_el: [],
            ukupni_trosak_el: [],

            ukupni_prihod_el: [],
            ukupni_prihod_kon: [],
            ukupni_prihod_ke: [],

        };
    },
    methods: {
        calculate() {
            this.god_tro_pog_clio_help = (this.god_km / 100) * this.auti[1].prosj_pot_en;
            this.god_tro_pog_zoe_help = ((this.god_km / 100) * this.auti[0].prosj_pot_en) / 10;
            this.god_tro_pog_twingo_ze_help = ((this.god_km / 100) * this.auti[2].prosj_pot_en) / 10;
            this.god_tro_pog_twingo_help = (this.god_km / 100) * this.auti[3].prosj_pot_en;

            this.god_tro_pog_captur_help = (this.god_km / 100) * this.auti[5].prosj_pot_en;
            this.god_tro_pog_captur_tech_help = ((this.god_km / 100) * this.auti[4].prosj_pot_en2) / 10;
            this.god_tro_pog_megane_help = (this.god_km / 100) * this.auti[7].prosj_pot_en;
            this.god_tro_pog_megane_tech_help = ((this.god_km / 100) * this.auti[6].prosj_pot_en2) / 10;

            this.god_tro_pog_clio = this.god_tro_pog_clio_help * this.cijena_euro_95;
            this.god_tro_pog_zoe = this.god_tro_pog_zoe_help * this.cijena_el_energije;
            this.god_tro_pog_twingo_ze = this.god_tro_pog_twingo_ze_help * this.cijena_el_energije
            this.god_tro_pog_twingo = this.god_tro_pog_twingo_help * this.cijena_euro_95

            this.god_tro_pog_captur = this.god_tro_pog_captur_help * this.cijena_euro_95
            this.god_tro_pog_captur_tech = this.god_tro_pog_captur_tech_help * this.cijena_el_energije
            this.god_tro_pog_megane = this.god_tro_pog_megane_help * this.cijena_euro_95
            this.god_tro_pog_megane_tech = this.god_tro_pog_megane_tech_help * this.cijena_el_energije

            this.god_emisija_zoe =
                this.auti[0].prosj_CO2_emisija *
                this.god_tro_pog_zoe_help *
                Math.pow(10, -3) *
                this.emisijski_faktor;
            this.god_emisija_clio =
                (this.god_km / 100) *
                (this.auti[1].prosj_CO2_emisija * 100) *
                Math.pow(10, -6);
            this.god_emisija_twingo_ze =
                this.auti[2].prosj_CO2_emisija *
                this.god_tro_pog_twingo_ze_help *
                Math.pow(10, -3) *
                this.emisijski_faktor;
            this.god_emisija_twingo =
                (this.god_km / 100) *
                (this.auti[3].prosj_CO2_emisija * 100) *
                Math.pow(10, -6);

            this.god_emisija_captur = (this.god_km / 100) *
                (this.auti[5].prosj_CO2_emisija * 100) * Math.pow(10, -6);
            this.god_emisija_captur_tech = this.auti[4].prosj_CO2_emisija * this.god_tro_pog_captur_tech_help *
                Math.pow(10, -3) * this.emisijski_faktor;
            this.god_emisija_megane = (this.god_km / 100) *
                (this.auti[7].prosj_CO2_emisija * 100) * Math.pow(10, -6);
            this.god_emisija_megane_tech = this.auti[6].prosj_CO2_emisija * this.god_tro_pog_megane_tech_help *
                Math.pow(10, -3) * this.emisijski_faktor;

            this.god_usteda_zoe_clio =
                ((this.god_emisija_clio - this.god_emisija_zoe) * 100) /
                this.god_emisija_clio;
            this.god_usteda_twingo_ze_twingo =
                ((this.god_emisija_twingo - this.god_emisija_twingo_ze) * 100) /
                this.god_emisija_twingo;

            this.god_usteda_captur_tech_captur = ((this.god_emisija_captur - this.god_emisija_captur_tech) * 100) /
                this.god_emisija_captur;
            this.god_usteda_megane_tech_megane = ((this.god_emisija_megane - this.god_emisija_megane_tech) * 100) /
                this.god_emisija_megane;

            this.usteda_drvece_zoe = (1000 * this.god_emisija_zoe) / 22;
            this.usteda_drvece_clio = (1000 * this.god_emisija_clio) / 22;
            this.usteda_drvece_twingo_ze = (1000 * this.god_emisija_twingo_ze) / 22;
            this.usteda_drvece_twingo = (1000 * this.god_emisija_twingo) / 22;

            this.usteda_drvece_captur_tech = (1000 * this.god_emisija_captur_tech) / 22;
            this.usteda_drvece_captur = (1000 * this.god_emisija_captur) / 22;
            this.usteda_drvece_megane_tech = (1000 * this.god_emisija_megane_tech) / 22;
            this.usteda_drvece_megane = (1000 * this.god_emisija_megane) / 22;

            this.usteda_drvece_zoe_clio =
                this.usteda_drvece_clio - this.usteda_drvece_zoe;
            this.usteda_drvece_twingo_ze_twingo =
                this.usteda_drvece_twingo - this.usteda_drvece_twingo_ze;

            this.usteda_drvece_captur_tech_captur =
                this.usteda_drvece_captur - this.usteda_drvece_captur_tech;
            this.usteda_drvece_megane_tech_megane =
                this.usteda_drvece_megane - this.usteda_drvece_megane_tech;

            this.usteda_voda_zoe =
                (this.god_emisija_zoe * Math.pow(10, 3)) / 2.65 / 1000;
            this.usteda_voda_clio =
                (this.god_emisija_clio * Math.pow(10, 3)) / 2.65 / 1000;
            this.usteda_voda_twingo_ze =
                (this.god_emisija_twingo_ze * Math.pow(10, 3)) / 2.65 / 1000;
            this.usteda_voda_twingo =
                (this.god_emisija_twingo * Math.pow(10, 3)) / 2.65 / 1000;

            this.usteda_voda_captur_tech =
                (this.god_emisija_captur_tech * Math.pow(10, 3)) / 2.65 / 1000;
            this.usteda_voda_captur =
                (this.god_emisija_captur * Math.pow(10, 3)) / 2.65 / 1000;
            this.usteda_voda_megane_tech =
                (this.god_emisija_megane_tech * Math.pow(10, 3)) / 2.65 / 1000;
            this.usteda_voda_megane =
                (this.god_emisija_megane * Math.pow(10, 3)) / 2.65 / 1000;

            this.usteda_voda_zoe_clio = this.usteda_voda_clio - this.usteda_voda_zoe;
            this.usteda_voda_twingo_ze_twingo = this.usteda_voda_twingo - this.usteda_voda_twingo_ze;

            this.usteda_voda_captur_tech_captur = this.usteda_voda_captur - this.usteda_voda_captur_tech;
            this.usteda_voda_megane_tech_megane = this.usteda_voda_megane - this.usteda_voda_megane_tech;

            this.uklanjanje_vozila_zoe_clio =
                ((this.god_emisija_clio - this.god_emisija_zoe) * Math.pow(10, 3)) /
                (123.4 * this.god_km);
            this.uklanjanje_vozila_twingo_ze_twingo =
                ((this.god_emisija_twingo - this.god_emisija_twingo_ze) *
                    Math.pow(10, 3)) /
                (123.4 * this.god_km);

            this.uklanjanje_vozila_captur_tech_captur =
                ((this.god_emisija_captur - this.god_emisija_captur_tech) * Math.pow(10, 3)) /
                (123.4 * this.god_km);
            this.uklanjanje_vozila_megane_tech_megane =
                ((this.god_emisija_megane - this.god_emisija_megane_tech) *
                    Math.pow(10, 3)) /
                (123.4 * this.god_km);

            this.atmosfera_zoe_clio = this.god_emisija_clio - this.god_emisija_zoe;
            this.atmosfera_twingo_ze_twingo =
                this.god_emisija_twingo - this.god_emisija_twingo_ze;

            this.atmosfera_captur_tech_captur = this.god_emisija_captur - this.god_emisija_captur_tech;
            this.atmosfera_megane_tech_megane =
                this.god_emisija_megane - this.god_emisija_megane_tech;

            this.calculateUkupniTroskovi();
            this.calculateTockaPokrica();

            this.doneCalculate = !this.doneCalculate;
            Vue.nextTick(() => {
                if (this.odabir_auta === "Clio") {
                    this.createChart1();
                } else if (this.odabir_auta === "Twingo") {
                    this.createChart2();
                } else if (this.odabir_auta === "Captur") {
                    this.createChart3();
                } else if (this.odabir_auta === "Megane") {
                    this.createChart4();
                }
                this.createChartExpenses();
                this.scrollToElement();
            });
        },

        calculateUkupniTroskovi() {
            for (let i = 0; i < 15; i++) {
                if (i === 0) {
                    this.ukupni_troskovi_zoe[i] = this.auti[0].ukupno_cijena + this.auti[0].teh_i_reg +
                        this.auti[0].osiguranje + this.auti[0].god_odrz + this.god_tro_pog_zoe;
                    this.ukupni_troskovi_clio[i] = this.auti[1].ukupno_cijena + this.auti[1].teh_i_reg +
                        this.auti[1].osiguranje + this.auti[1].god_odrz + this.god_tro_pog_clio;

                    this.ukupni_troskovi_twingo_ze[i] = this.auti[2].ukupno_cijena + this.auti[2].teh_i_reg +
                        this.auti[2].osiguranje + this.auti[2].god_odrz + this.god_tro_pog_twingo_ze;
                    this.ukupni_troskovi_twingo[i] = this.auti[3].ukupno_cijena + this.auti[3].teh_i_reg +
                        this.auti[3].osiguranje + this.auti[3].god_odrz + this.god_tro_pog_twingo;

                    this.ukupni_troskovi_captur_tech[i] = this.auti[4].ukupno_cijena + this.auti[4].teh_i_reg +
                        this.auti[4].osiguranje + this.auti[4].god_odrz + this.god_tro_pog_captur_tech;
                    this.ukupni_troskovi_captur[i] = this.auti[5].ukupno_cijena + this.auti[5].teh_i_reg +
                        this.auti[5].osiguranje + this.auti[5].god_odrz + this.god_tro_pog_captur;

                    this.ukupni_troskovi_megane_tech[i] = this.auti[6].ukupno_cijena + this.auti[6].teh_i_reg +
                        this.auti[6].osiguranje + this.auti[6].god_odrz + this.god_tro_pog_megane_tech;
                    this.ukupni_troskovi_megane[i] = this.auti[7].ukupno_cijena + this.auti[7].teh_i_reg +
                        this.auti[7].osiguranje + this.auti[7].god_odrz + this.god_tro_pog_megane;
                } else {
                    this.ukupni_troskovi_zoe[i] = this.ukupni_troskovi_zoe[i - 1] + this.auti[0].teh_i_reg +
                        this.auti[0].osiguranje + this.auti[0].god_odrz + this.god_tro_pog_zoe;
                    this.ukupni_troskovi_clio[i] = this.ukupni_troskovi_clio[i - 1] + this.auti[1].teh_i_reg +
                        this.auti[1].osiguranje + this.auti[1].god_odrz + this.god_tro_pog_clio;

                    this.ukupni_troskovi_twingo_ze[i] = this.ukupni_troskovi_twingo_ze[i - 1] + this.auti[2].teh_i_reg +
                        this.auti[2].osiguranje + this.auti[2].god_odrz + this.god_tro_pog_twingo_ze;
                    this.ukupni_troskovi_twingo[i] = this.ukupni_troskovi_twingo[i - 1] + this.auti[3].teh_i_reg +
                        this.auti[3].osiguranje + this.auti[3].god_odrz + this.god_tro_pog_twingo;

                    this.ukupni_troskovi_captur_tech[i] = this.ukupni_troskovi_captur_tech[i - 1] + this.auti[4].teh_i_reg +
                        this.auti[4].osiguranje + this.auti[4].god_odrz + this.god_tro_pog_captur_tech;
                    this.ukupni_troskovi_captur[i] = this.ukupni_troskovi_captur[i - 1] + this.auti[5].teh_i_reg +
                        this.auti[5].osiguranje + this.auti[5].god_odrz + this.god_tro_pog_captur;

                    this.ukupni_troskovi_megane_tech[i] = this.ukupni_troskovi_megane_tech[i - 1] + this.auti[6].teh_i_reg +
                        this.auti[6].osiguranje + this.auti[6].god_odrz + this.god_tro_pog_megane_tech;
                    this.ukupni_troskovi_megane[i] = this.ukupni_troskovi_megane[i - 1] + this.auti[7].teh_i_reg +
                        this.auti[7].osiguranje + this.auti[7].god_odrz + this.god_tro_pog_megane;
                }
            }
        },

        calculateTockaPokrica() {
            if (this.odabir_auta === "Clio") {
                for (let i = 0; i < 15; i++) {
                    if (i === 0) {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_zoe;
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_clio;

                        this.cijena_voz_po_god[i] = this.auti[0].ukupno_cijena / 15;
                    } else {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_zoe + this.ukupni_prihod_el[i - 1];
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_clio + this.ukupni_prihod_kon[i - 1];

                        this.cijena_voz_po_god[i] = this.cijena_voz_po_god[0] * (i + 1);
                    }
                    this.ukupni_prihod_ke[i] = this.ukupni_prihod_kon[i] - this.ukupni_prihod_el[i];
                    this.fiksni_trosak_el[i] = this.cijena_voz_po_god[0] + this.auti[0].teh_i_reg + this.auti[0].osiguranje + this.auti[0].god_odrz;
                }
            } else if (this.odabir_auta === "Twingo") {
                for (let i = 0; i < 15; i++) {
                    if (i === 0) {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_twingo_ze;
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_twingo;

                        this.cijena_voz_po_god[i] = this.auti[2].ukupno_cijena / 15;
                    } else {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_twingo_ze + this.ukupni_prihod_el[i - 1];
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_twingo + this.ukupni_prihod_kon[i - 1];

                        this.cijena_voz_po_god[i] = this.cijena_voz_po_god[2] * (i + 1);
                    }
                    this.ukupni_prihod_ke[i] = this.ukupni_prihod_kon[i] - this.ukupni_prihod_el[i];
                    this.fiksni_trosak_el[i] = this.cijena_voz_po_god[0] + this.auti[2].teh_i_reg + this.auti[2].osiguranje + this.auti[2].god_odrz;
                }
            } else if (this.odabir_auta === "Captur") {
                for (let i = 0; i < 15; i++) {
                    if (i === 0) {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_captur_tech;
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_captur;

                        this.cijena_voz_po_god[i] = this.auti[4].ukupno_cijena / 15;
                    } else {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_captur_tech + this.ukupni_prihod_el[i - 1];
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_captur + this.ukupni_prihod_kon[i - 1];

                        this.cijena_voz_po_god[i] = this.cijena_voz_po_god[4] * (i + 1);
                    }
                    this.ukupni_prihod_ke[i] = this.ukupni_prihod_kon[i] - this.ukupni_prihod_el[i];
                    this.fiksni_trosak_el[i] = this.cijena_voz_po_god[0] + this.auti[4].teh_i_reg + this.auti[4].osiguranje + this.auti[4].god_odrz;
                }
            } else if (this.odabir_auta === "Megane") {
                for (let i = 0; i < 15; i++) {
                    if (i === 0) {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_megane_tech;
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_megane;

                        this.cijena_voz_po_god[i] = this.auti[6].ukupno_cijena / 15;
                    } else {
                        this.ukupni_prihod_el[i] = this.god_tro_pog_megane_tech + this.ukupni_prihod_el[i - 1];
                        this.ukupni_prihod_kon[i] = this.god_tro_pog_megane + this.ukupni_prihod_kon[i - 1];

                        this.cijena_voz_po_god[i] = this.cijena_voz_po_god[6] * (i + 1);
                    }
                    this.ukupni_prihod_ke[i] = this.ukupni_prihod_kon[i] - this.ukupni_prihod_el[i];
                    this.fiksni_trosak_el[i] = this.cijena_voz_po_god[0] + this.auti[6].teh_i_reg + this.auti[6].osiguranje + this.auti[6].god_odrz;
                }
            }

            for (let i = 0; i < 15; i++) {
                if (i === 0) {
                    //this.ukupni_trosak_el[i] = this.fiksni_trosak_el + this.ukupni_prihod_el[i];
                    this.ukupni_trosak_el[i] = this.fiksni_trosak_el[i];
                } else {
                    this.ukupni_trosak_el[i] = this.fiksni_trosak_el[i] + this.ukupni_trosak_el[i - 1];
                }
            }
        },

        createChartExpenses(){
            var lineExpenses = this.$el.querySelector('#lineExpenses').getContext('2d');
            new Chart(lineExpenses, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                    datasets: [{
                            label: 'Fiksni troškovi električno vozilo',
                            data: this.fiksni_trosak_el,
                            borderColor: ['#720000'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Ukupni troškovi električno vozilo',
                            data: this.ukupni_trosak_el,
                            borderColor: ['#00b300'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Ukupni prihod električno vozilo prema konvencionalnom',
                            data: this.ukupni_prihod_ke,
                            borderColor: ['#00bfff'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                        }],
                    }
                }
            });
        },

        createChart1() {
            var lineZoeClio = this.$el.querySelector('#lineZoeClio').getContext('2d');
            new Chart(lineZoeClio, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                    datasets: [{
                            label: 'Zoe',
                            data: this.ukupni_troskovi_zoe,
                            borderColor: ['#00b300'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Clio',
                            data: this.ukupni_troskovi_clio,
                            borderColor: ['#00bfff'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                        }],
                    }
                }
            });
        },

        createChart2() {
            var lineTwingo = this.$el.querySelector('#lineTwingo').getContext('2d');
            new Chart(lineTwingo, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                    datasets: [{
                            label: 'Twingo Z.E.',
                            data: this.ukupni_troskovi_twingo_ze,
                            borderColor: ['#720000'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Twingo',
                            data: this.ukupni_troskovi_twingo,
                            borderColor: ['#e69500'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                        }],
                    }
                }
            });
        },

        createChart3() {
            var lineCaptur = this.$el.querySelector('#lineCaptur').getContext('2d');
            new Chart(lineCaptur, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                    datasets: [{
                            label: 'Captur Tech',
                            data: this.ukupni_troskovi_captur_tech,
                            borderColor: ['#00b300'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Captur',
                            data: this.ukupni_troskovi_captur,
                            borderColor: ['#00bfff'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                        }],
                    }
                }
            });
        },

        createChart4() {
            var lineMegane = this.$el.querySelector('#lineMegane').getContext('2d');
            new Chart(lineMegane, {
                type: 'line',
                data: {
                    labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                    datasets: [{
                            label: 'Megane Tech',
                            data: this.ukupni_troskovi_megane_tech,
                            borderColor: ['#720000'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        },
                        {
                            label: 'Megane',
                            data: this.ukupni_troskovi_megane,
                            borderColor: ['#e69500'],
                            backgroundColor: 'transparent',
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                        }],
                    }
                }
            });
        },

        scrollToElement() {
            const el = this.$el.getElementsByClassName("rezultat")[0];

            if (el) {
                el.scrollIntoView();
            }
        },
    },
    watch: {
        odabir_auta() {
            if (this.doneCalculate === true) {
                this.doneCalculate = !this.doneCalculate;
            }
        }
    }
};
</script>

<style scoped>
@import "../css/main.css";
</style>
